<template>
    <div class="af3-main-loop-container" :class="{'af3-main-loop-container-no-filter_bar': !options.floor_plans_loop_show_filter_bar}">
        
        <sort-by-component
            :default-sort="effectiveDefaultSort"
            :sort-options="sortOptionsList"
            @sortBySelected="handleSortBySelected"
            @filterByMobileOpen="handleFilterByMobileOpen" />

        <filter-bar-component 
        v-if="options.floor_plans_loop_show_filter_bar"
        :resources_url="resources_url"
        :options="options"
        :price_min="price_min" 
        :price_max="price_max" 
        :bathrooms_min="bathrooms_min" 
        :bathrooms_max="bathrooms_max" 
        :bedrooms_min="bedrooms_min" 
        :bedrooms_max="bedrooms_max"
        :available_bedrooms="available_bedrooms"
        :available_bathrooms="available_bathrooms"
        :size_min="size_min" 
        :size_max="size_max" 
        :sort_by="sort_by"
        :available_lease_terms="available_lease_terms"
        @filterBySelected="handleFilterBySelected"
        @filterByMobileClose="handleFilterByMobileClose"
        :is_filter_by_mobile_open="is_filter_by_mobile_open"
        />

        


        <div class="af3-main-loop-floor-plans-main-container">
          
          
          <div class="af3-main-loop-floor-plans" v-if="filtered_floor_plans.length > 0">
            <template v-for="floor_plan in filtered_floor_plans" :key="floor_plan.id"> 
              <template v-if="options.floor_plans_loop_link_floorplans"> 
                <a :href="floor_plan.link_floorplan" class="af3-floor-plan-card-link">
                  <floor-plan-card-component :resources_url="resources_url" :floor_plan="floor_plan" :options="options" :selected_lease_term="selected_lease_term" />
                </a>
              </template>
              <template v-else> 
                <floor-plan-card-component :resources_url="resources_url" :floor_plan="floor_plan" :options="options" :selected_lease_term="selected_lease_term" />
              </template>
            </template>

          </div>

          <div class="af3-main-loop-floor-plans-back-to-top" v-if="filtered_floor_plans.length > 0">
            <button @click="handleBackToTop">Back to Top</button>
          </div>

          




          
          <div class="af3-main-loop-floor-plans" v-else>
            <div class="af3-main-loop-floor-plans-no-results">
              <p>No results found</p>
              <p>Please try again with different filters</p>
            </div>
          </div>
        </div>

    </div>

   

   


</template>
  
<script>

import { defineComponent, ref, computed, watch, onMounted, reactive } from 'vue';
import FloorPlanCardComponent from './FloorPlanCardComponent.vue';
import SortByComponent from './SortByComponent.vue';
import FilterBarComponent from './FilterBarComponent.vue';
export default defineComponent({
    components: { FloorPlanCardComponent, SortByComponent, FilterBarComponent },
   
    props: {
      floor_plans: {
        type: Array,
        required: true
      },
      options: {
        type: Object,
        required: true
      },
      resources_url: {
        type: String,
        required: true
      }
    },

    setup(props) {

      const filtered_floor_plans = ref([]);
      const price_min = ref(0);
      const price_max = ref(0);
      const bathrooms_min = ref(0);
      const bathrooms_max = ref(0);
      const bedrooms_min = ref(0);
      const bedrooms_max = ref(0);
      const size_min = ref(0);
      const size_max = ref(0);
      // Use PHP-provided sort options when present (single source of truth), else fallback for older/cached pages
      const DEFAULT_SORT_OPTIONS = [
        { value: 'least_bedrooms', label: 'Least Bedrooms' }, { value: 'most_bedrooms', label: 'Most Bedrooms' },
        { value: 'lowest_price', label: 'Lowest Price' }, { value: 'highest_price', label: 'Highest Price' },
        { value: 'largest_unit', label: 'Largest Unit' }, { value: 'smallest_unit', label: 'Smallest Unit' }
      ];
      const sortOptionsList = computed(() => {
        const fromOptions = props.options?.floor_plans_loop_available_sorts;
        return Array.isArray(fromOptions) && fromOptions.length > 0 ? fromOptions : DEFAULT_SORT_OPTIONS;
      });
      const SORT_VALUES = computed(() => sortOptionsList.value.map((o) => o.value));
      const validDefaultSort = (val) => (val && SORT_VALUES.value.includes(val)) ? val : 'least_bedrooms';
      const sort_by = ref(validDefaultSort(props.options?.floor_plans_loop_default_sort) || 'least_bedrooms');
      const effectiveDefaultSort = computed(() => validDefaultSort(props.options?.floor_plans_loop_default_sort));
      const available_bedrooms = ref([]);
      const available_bathrooms = ref([]);
      const available_lease_terms = ref([]);
      const selected_lease_term = ref(null);
      const is_filter_by_mobile_open = ref(false);

    

      // Helper to read URL parameters
      const getUrlParams = () => {
        const url = new URL(window.location.href);
        const params = url.searchParams;
        
        // Create a form object based on URL parameters
        const form = {
          price_min: params.has('price_min') ? Number(params.get('price_min')) : price_min.value,
          price_max: params.has('price_max') ? Number(params.get('price_max')) : price_max.value,
          bathrooms_value: params.has('bathrooms_value') ? 
            (params.get('bathrooms_value') === 'null' ? null : Number(params.get('bathrooms_value'))) : 
            null,
          bedrooms_value: params.has('bedrooms_value') ? 
            (params.get('bedrooms_value') === 'null' ? null : Number(params.get('bedrooms_value'))) : 
            null,
          size_min: params.has('size_min') ? Number(params.get('size_min')) : size_min.value,
          size_max: params.has('size_max') ? Number(params.get('size_max')) : size_max.value,
          show_available_only: params.has('show_available_only') ? params.get('show_available_only') === 'true' : props.options.floor_plans_loop_show_sold_out ? false : true,
          sort_by: params.has('sort_by') ? (SORT_VALUES.value.includes(params.get('sort_by')) ? params.get('sort_by') : sort_by.value) : sort_by.value,
          availability_date: params.has('availability_date') ? params.get('availability_date') : null,
          lease_term: params.has('lease_term') ? params.get('lease_term') : null
        };


        
        return form;
      };

      // Helper to apply the default display (no lease term filter)
      const applyDefaultDisplay = (urlParams) => {
        const showAvailableOnly = urlParams.show_available_only;
        
        if (showAvailableOnly === false) {
          // User explicitly wants to see all floor plans, including sold out ones
          filtered_floor_plans.value = [...props.floor_plans];
        } else if (props.options.floor_plans_loop_show_sold_out) {
          // Settings say to show sold out floor plans by default
          filtered_floor_plans.value = [...props.floor_plans];
        } else {
          // Default behavior: hide sold out floor plans
          filtered_floor_plans.value = [...props.floor_plans.filter(plan => !plan.is_sold_out)];
        }
        
        // Apply initial sorting
        handleSortBySelected(sort_by.value);
      };

      onMounted(() => {
        // get the available values for lease terms from the floor plans
        available_lease_terms.value = [...new Set(
          props.floor_plans.flatMap(plan => plan.lease_options)
            .filter((option, index, self) => {
              return self.findIndex(o => o.composite_key === option.composite_key) === index;
            })
        )];
        
        // Set min/max values from floor plans
        const prices = props.floor_plans.map(plan => plan.price_min).filter(price => price !== null && !isNaN(price));
        const bathrooms = props.floor_plans.map(plan => plan.bathrooms).filter(value => value !== null && !isNaN(value));
        const bedrooms = props.floor_plans.map(plan => plan.bedrooms).filter(value => value !== null && !isNaN(value));
        const sizes = props.floor_plans.map(plan => plan.size_min).filter(size => size !== null && !isNaN(size));
        
        price_min.value = Math.min(...prices) || 0;
        price_max.value = Math.max(...prices) || 0;
        bathrooms_min.value = Math.min(...bathrooms) || 0;
        bathrooms_max.value = Math.max(...bathrooms) || 0;
        bedrooms_min.value = Math.min(...bedrooms) || 0;
        bedrooms_max.value = Math.max(...bedrooms) || 0;
        size_min.value = Math.min(...sizes) || 0;
        size_max.value = Math.max(...sizes) || 0;

        // get the available values for bedrooms and bathrooms
        available_bedrooms.value = [...new Set(props.floor_plans.map(plan => Number(plan.bedrooms)))].filter(value => value !== null && !isNaN(value));
        available_bathrooms.value = [...new Set(props.floor_plans.map(plan => Number(plan.bathrooms)))].filter(value => value !== null && !isNaN(value));
        
// When no URL sort_by, use option default so getUrlParams and SortByComponent stay in sync
        const url = new URL(window.location.href);
        if (!url.searchParams.has('sort_by')) {
          sort_by.value = validDefaultSort(props.options?.floor_plans_loop_default_sort);
        }

        // Check if URL has filter parameters
        const urlParams = getUrlParams();

        // Only consider URL to have filters if the parameters contain values that are 
        // different from the default values or aren't null 
        const hasFilterParams = (
          // price filter has meaningful values
          (urlParams.price_min > 0 && urlParams.price_min !== price_min.value) || 
          (urlParams.price_max > 0 && urlParams.price_max !== price_max.value) ||
          
          // bedrooms or bathrooms have specific selections
          (urlParams.bedrooms_value !== null && urlParams.bedrooms_value !== -1) ||
          (urlParams.bathrooms_value !== null && urlParams.bathrooms_value !== -1) ||
          
          // size filter has meaningful values
          (urlParams.size_min > 0 && urlParams.size_min !== size_min.value) ||
          (urlParams.size_max > 0 && urlParams.size_max !== size_max.value) ||
          
          // availability date is selected
          urlParams.availability_date !== null ||
          
          // lease term is selected
          (urlParams.lease_term !== null && urlParams.lease_term !== '')
        );
        
        if (hasFilterParams) {
          // Don't set filtered_floor_plans to default (we'll set it in handleFilterBySelected)
          // but do update the sort_by value
          sort_by.value = urlParams.sort_by;
          
          // Apply filters from URL parameters
          handleFilterBySelected(urlParams);
        } else {
          // Check if a default lease term is configured in af3_options
          const defaultLeaseTermSlug = props.options.default_lease_term;
          if (defaultLeaseTermSlug && defaultLeaseTermSlug !== '0' && available_lease_terms.value.length > 0) {
            // Find the matching lease term by building a slug from lease term data
            // The default_lease_term uses sanitize_title(name)-start_date-end_date format
            const matchingTerm = available_lease_terms.value.find(term => {
              const termSlug = term.lease_term_name.toLowerCase()
                .replace(/&.+?;/g, '')
                .replace(/[^a-z0-9\s-]/g, '')
                .replace(/\s+/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-+|-+$/g, '')
                + '-' + term.start_date + '-' + term.end_date;
              return termSlug === defaultLeaseTermSlug;
            });

            if (matchingTerm) {
              // Apply the default lease term as a filter
              const form = getUrlParams();
              form.lease_term = matchingTerm.composite_key;
              handleFilterBySelected(form);
            } else {
              // Default lease term not found in available terms, fall through to default behavior
              applyDefaultDisplay(urlParams);
            }
          } else {
            applyDefaultDisplay(urlParams);
          }
        }
      });

      const handleSortBySelected = (value) => {
        sort_by.value = value;

        // If no filters have been applied yet, use all floor plans instead of the filtered ones
        // which might be an empty array due to invalid default filter values
        let plansList = filtered_floor_plans.value;
        
        // If we get no results due to invalid filter values (like price_min = 0, price_max = 0),
        // use the original floor plans with just the sold out filter
        // if (plansList.length === 0) {
        //   plansList = props.floor_plans.filter(plan => !plan.is_sold_out);
        // }
     
        // Create a new array for proper reactivity
        const sortedFloorPlans = [...plansList];
        // Keep cases in sync with get_available_sort_options() in class-af3-shortcodes-options.php
        switch (value) {
          case 'least_bedrooms':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => a.bedrooms - b.bedrooms);
            break;
          case 'most_bedrooms':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => b.bedrooms - a.bedrooms);
            break;
          case 'lowest_price':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => a.price_min - b.price_min);
            break;
          case 'highest_price':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => b.price_min - a.price_min);
            break;
          case 'largest_unit':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => b.size_min - a.size_min);
            break;
          case 'smallest_unit':
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => a.size_min - b.size_min);
            break;  
          default:
            filtered_floor_plans.value = sortedFloorPlans.sort((a, b) => a.bedrooms - b.bedrooms);
            break;
        }
      }

      const handleFilterBySelected = (form) => {
        // Don't reset selected_lease_term at the beginning
        
        // Apply all filters to the floor plans
        let filteredPlans = [...props.floor_plans];
        
        // Filter by availability if needed
        if (form.show_available_only) {
          filteredPlans = filteredPlans.filter(plan => !plan.is_sold_out);
        } else {
          // Show all floor plans when show_available_only is false
          filteredPlans = [...props.floor_plans];
        }
        
        // Filter by availability date if selected
        if (form.availability_date) {
          
          filteredPlans = filteredPlans.filter(plan => {
            // Skip plans with no availability
            if (!plan.first_available_date) {
              return false;
            }
            
            // Compare dates - only show floorplans where first_available_date is LESS than or equal to selected date
            // This ensures we only show floorplans that are available on or before the user's desired move-in date
            return plan.first_available_date <= form.availability_date;
          });
        }
        
        // Filter by price range only if valid range is provided
        if (form.price_min > 0 || form.price_max > 0) {
          // If max is 0 or less than min, set it to a very high number
          const effectiveMax = (form.price_max <= 0 || form.price_max < form.price_min) 
                              ? Number.MAX_SAFE_INTEGER 
                              : form.price_max;
          
          filteredPlans = filteredPlans.filter(plan => {
            // Check if price is within the selected range
            return plan.price_min >= form.price_min && plan.price_min <= effectiveMax;
          });
        }
        
        // Filter by bathrooms - using the new bathrooms_value format
        if (form.bathrooms_value !== null && form.bathrooms_value !== -1) {
          
          filteredPlans = filteredPlans.filter(plan => {
            // Convert both to numbers for reliable comparison
            return Number(plan.bathrooms) === Number(form.bathrooms_value);
          });
        }
        
        // Filter by bedrooms - using the new bedrooms_value format
        if (form.bedrooms_value !== null && form.bedrooms_value !== -1) {
          
          filteredPlans = filteredPlans.filter(plan => {
            // Convert both to numbers for reliable comparison
            return Number(plan.bedrooms) === Number(form.bedrooms_value);
          });
        }
        
        // Filter by size only if valid range is provided
        if (form.size_min > 0 || form.size_max > 0) {
          // If max is 0 or less than min, set it to a very high number
          const effectiveMax = (form.size_max <= 0 || form.size_max < form.size_min) 
                              ? Number.MAX_SAFE_INTEGER 
                              : form.size_max;
          
          filteredPlans = filteredPlans.filter(plan => {
            return plan.size_min >= form.size_min && plan.size_min <= effectiveMax;
          });
        }

        // Update lease term based on selection
        if (form.lease_term && form.lease_term.trim() !== '') {
          selected_lease_term.value = form.lease_term;
          filteredPlans = filteredPlans.filter(plan => {
            // Check if the lease term matches the selected value 
            return plan.lease_options.some(option => option.composite_key === form.lease_term);
          });
        } else {
          // Explicitly clear the lease term when "Any" is selected (empty string)
          selected_lease_term.value = '';
        }
        
        // Update the filtered floor plans
        filtered_floor_plans.value = filteredPlans;
        
        // Apply the current sort to the filtered results
        handleSortBySelected(form.sort_by || sort_by.value);
      }

      const handleFilterByMobileOpen = () => {
        is_filter_by_mobile_open.value = !is_filter_by_mobile_open.value;
      }

      const handleFilterByMobileClose = () => {
        is_filter_by_mobile_open.value = false;
      }

      const handleBackToTop = () => {
        let headerheight = props.options.floor_plans_loop_sticky_filter_bar_top;
        const container = document.querySelector('#af3-shortcodes-floor-plan-page-main-component');
        if (container) {
          const rect = container.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const elementTop = rect.top + scrollTop;
          
          window.scrollTo({
            top: elementTop - headerheight,
            behavior: 'smooth'
          });
        }
      }

            

    return {
      filtered_floor_plans,
      price_min,
      price_max,
      bathrooms_min,
      bathrooms_max,
      bedrooms_min,
      bedrooms_max,
      size_min,
      size_max,
      sort_by,
      effectiveDefaultSort,
      sortOptionsList,
      available_bedrooms,
      available_bathrooms,
      available_lease_terms,
      selected_lease_term,
      is_filter_by_mobile_open,
      handleSortBySelected,
      handleFilterBySelected,
      handleFilterByMobileClose,
      handleFilterByMobileOpen,
      handleBackToTop
    };
  },


  
  
});
</script>